import apiClient from '../client';
import type { GeocodeResult } from '../../types';

const locationService = {
  search: async (query: string) => {
    const response = await apiClient.get<GeocodeResult[]>('/location/search', { params: { q: query } });
    return response.data;
  },
};

export default locationService;
